import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ITEM_INFO_BOTTOM_PART_TRANSLATIONS } from '../Panel/BottomParts/ItemInfoTable/ItemInfoTable.constants';
import { GenericNotification } from './GenericNotification';

export const urlCopiedNotification =
  () =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={<FormattedMessage id={ITEM_INFO_BOTTOM_PART_TRANSLATIONS.urlCopied} />}
      />
    );
